import { LitElement, TemplateResult, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import globalStyles from './styles/outline-breadcrumb.global.pcss?inline';
import encapsulatedStyles from './styles/outline-breadcrumb.encapsulated.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import { classMap } from 'lit/directives/class-map.js';
import '../outline-icon/outline-icon';
import '../outline-container/outline-container';

const componentName = 'outline-breadcrumb'

/**
 * The OutlineBreadcrumb component
 * @element outline-breadcrumb
 * @slot - default
 */

@customElement('outline-breadcrumb')
export class OutlineBreadcrumb extends LitElement {

    /**
     * If url is homepage.
     */
    @state()
    isHome: boolean;

    adoptedStyleSheets = new AdoptedStyleSheets(this, {
        globalCSS: globalStyles,
        encapsulatedCSS: encapsulatedStyles,
    });

    updated() {
        this.isHome = window.location.pathname === '/';        
    }

    render(): TemplateResult {
        const classes = {
            'breadcrumb-wrapper': true,
          };
      
          return html`
          <outline-container>
            <div class=${classMap(classes)}>
                ${!this.isHome ? html`<a href="/" class="home-icon" aria-label="return to homepage">
                    <outline-icon icon='${`<i class="fa-solid fa-house"></i>`}' size="0.875rem" color="var(--outline-white)"></outline-icon>
                </a>` : ''
                }
                <slot></slot>
            </div>
          </outline-container>
            `
            ;
    }

}

/**
 * Declare the component in the global HTMLElementTagNameMap
 */
declare global {
    interface HTMLElementTagNameMap {
        [componentName]: OutlineBreadcrumb;
    }
}